export const internalUserEmails = [
  'markitecht@gmail.com',
  'erik@ipsumcreative.com',
  'gwendolynr@gmail.com',
  'erin@day.ai',
  'michael.g.pici@gmail.com',
  'christopher@theproviders.com',
  'daphne@day.ai',
  'daphnegrayson@gmail.com',
  'stephen@day.ai',
  'gwen@day.ai',
  'will@day.ai',
  'todd@day.ai',
]

export const isInternalUser = (user) => {
  return internalUserEmails.includes(user.email)
}

export const gatedForWorkAccountRemediationBanner = ['michael.g.pici@gmail.com']

// Orgs & People Tables / Custom Properties
export const ungatedForDayObjectsPart2 = (_) => {
  return true
}

// New Sidebars, Sources & Reasoning
export const ungatedForAssistant = (_user) => {
  return true
}

export const ungatedForSearchIndex2 = (_user) => {
  return true // ['markitecht@gmail.com', 'daphne@day.ai'].includes(_user.email)
}

export const ungatedWorkspacesForLogoDev = (workspaceId) => {
  return [
    //'7d014738-da3a-4c11-aced-2ce58715901d',
    //'85334f81-c4ed-42e9-82cf-71fd4638e9ad',
  ].includes(workspaceId)
}

export const ungatedForKanbanBoard = (_) => {
  return true
}

export const ungatedForNewMeetingsInSidebar = (user) => {
  return [
    'markitecht@gmail.com',
    'alfred@listenlabs.ai',
    'sara@melodi.fyi',
  ].includes(user.email)
}

export const ungatedForActivityReporting = (user) => {
  return ['markitecht@gmail.com'].includes(user.email)
}

export const ungatedForMarketing = (user) => {
  return ['markitecht@gmail.com', 'aj@parcha.ai', 'daphne@day.ai'].includes(
    user.email
  )
}

export const ungatedForCustomers = (user) => {
  return ['markitecht@gmail.com'].includes(user.email)
}

export const ungatedForProduct = (user) => {
  return ['markitecht@gmail.com', 'daphne@day.ai'].includes(user.email)
}

export const ungatedForInbox = (user) => {
  return internalUserEmails.includes(user.email)
}

export const ungatedForKnowledge = (user) => {
  return [].includes(user.email)
}

export const ungatedForSuggestedContextV2 = (_user) => {
  return true
}
